module.exports = __webpack_public_path__ + "img/jiabin3.0252e04b.png";